import { createContext, Component } from 'react';

export enum EBoardType {
  MIAN = 'main',
  SECONDARY = 'secondary',
}

export type TBoardManagerCtxState = {
  board: EBoardType;
};

const defaultValue = {
  board: EBoardType.MIAN,
};

export const BoardManagerCtx = createContext<TBoardManagerCtxState>(defaultValue);
export const { Provider: BoardManagerCtxProvider, Consumer: BoardManagerCtxConsumer } =
  BoardManagerCtx;

export const withBoardManagerContext = (Comp: typeof Component) => {
  return function WithBoardManagerContext(props: any) {
    return (
      <BoardManagerCtxConsumer>
        {(common) => <Comp common={common} {...props} />}
      </BoardManagerCtxConsumer>
    );
  };
};
